import { PhoneIcon } from "@heroicons/react/24/outline";

/** The phone number in a quote-flow header's `actions` slot: the line the
 * visitor should call from this screen. */
export default function HeaderPhone({
  line,
}: {
  line: { href: string; label: string };
}) {
  return (
    <a
      href={line.href}
      className="flex h-[38px] items-center gap-1.5 whitespace-nowrap text-sm font-bold text-soil hover:text-plum"
    >
      <PhoneIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
      <span className="ph-no-capture">{line.label}</span>
    </a>
  );
}
